import React from 'react';

const Button = ({ children, variant = 'primary', className = '', onClick }) => {
  const baseStyle = "inline-flex items-center justify-center px-10 py-5 text-[10px] md:text-[11px] tracking-[0.3em] uppercase transition-all duration-700 relative group overflow-hidden border";
  
  const variants = {
    primary: "bg-gold border-gold text-charcoal hover:bg-ivory hover:border-ivory hover:text-charcoal font-bold",
    secondary: "bg-transparent text-ivory border-gold/40 hover:border-gold hover:bg-gold/5 font-medium",
    text: "bg-transparent text-gold hover:text-ivory border-transparent border-b-gold/20 hover:border-b-ivory pb-1 px-0 py-0"
  };

  return (
    <button 
      className={`${baseStyle} ${variants[variant]} ${className}`}
      onClick={onClick}
    >
      <span className="relative z-10">{children}</span>
      {variant === 'primary' && (
        <div className="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-500"></div>
      )}
    </button>
  );
};

export default Button;